import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { IconFacebook24, IconTwitter24, IconMail24 } from '@fabric-ds/icons/react';

import { trackClick } from '@/lib/tracking/tracking';
import styles from './styles.module.css';

export const ShareButtons = ({ adId, heading, isEnabled }) => {
    const track = (name, type) => {
        if (isEnabled) {
            trackClick({
                type: 'Click',
                intent: 'Share',
                name: 'Share ad',
                object: {
                    id: `share_ad_${name}`,
                    type: 'UIElement',
                    name: `${type} icon`,
                    items: [
                        {
                            type: 'ClassifiedAd',
                            id: adId,
                            contentId: adId.toString(),
                            name: heading,
                            category: 'travel > holiday rental',
                        },
                    ],
                    hasExtendedProfile: false,
                },
                vertical: {
                    name: 'travel',
                    subVertical: 'holiday_rental',
                },
            });
        }
    };

    const renderLinkTitle = (enabledPrefix, disabledPrefix, postfix) =>
        isEnabled ? `${enabledPrefix} ${postfix}` : `Når annonsen er aktiv kan du ${disabledPrefix} ${postfix}`;

    const mailToLink = `mailto:?subject=Tips: ${heading}&body=Jeg fant dette på finn.no: https://www.finn.no/${adId}`;
    const facebookShareLink = `https://www.facebook.com/sharer/sharer.php?u=https://www.finn.no/${adId}?taid%3DShare_ad_facebook`;
    const twitterShareLink =
        `https://twitter.com/intent/tweet?hashtags=FINN_no&related=Finn_no&url=https://www.finn.no/${adId}` +
        `?taid%3DShare_ad_twitter&text=${heading}`;

    return (
        <div className="inline-block sm:space-x-4" data-testid="toolbar">
            <a
                className={cn(styles.button, 'button button--pill p-8', {
                    [styles['button--highlight']]: isEnabled,
                })}
                title={renderLinkTitle('Tips', 'tipse', 'en venn')}
                href={isEnabled ? mailToLink : null}
                rel="noopener noreferrer nofollow external"
                target="_blank"
                aria-disabled={!isEnabled}
                onClick={() => track('tip-a-friend', 'Email')}
                data-testid="tipAFriend">
                <IconMail24 />
            </a>
            <a
                className={cn(styles.button, 'button button--pill p-8', {
                    [styles['button--highlight']]: isEnabled,
                })}
                title={renderLinkTitle('Del', 'dele', 'på Facebook')}
                href={isEnabled ? facebookShareLink : null}
                rel="noopener noreferrer nofollow external"
                target="_blank"
                aria-disabled={!isEnabled}
                style={{ color: !isEnabled ? '#dfe4e8' : '' }}
                onClick={() => track('share-facebook', 'Facebook')}
                data-testid="shareFacebook">
                <IconFacebook24 />
            </a>
            <a
                className={cn(styles.button, 'button button--pill p-8', {
                    [styles['button--highlight']]: isEnabled,
                })}
                title={renderLinkTitle('Del', 'dele', 'på Twitter')}
                href={isEnabled ? twitterShareLink : null}
                rel="noopener noreferrer nofollow external"
                target="_blank"
                aria-disabled={!isEnabled}
                style={{ color: !isEnabled ? '#dfe4e8' : '' }}
                onClick={() => track('share-twitter', 'Twitter')}
                data-testid="shareTwitter">
                <IconTwitter24 />
            </a>
        </div>
    );
};

ShareButtons.propTypes = {
    adId: PropTypes.number.isRequired,
    heading: PropTypes.string.isRequired,
    isEnabled: PropTypes.bool.isRequired,
};
